// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5c089d66] .wapShow>a{border-bottom:1px solid #ccc}[data-v-5c089d66] .featuredMessages{background:var(--featuredFont);color:#fff;padding:3px 5px;border-radius:6px;float:right;font-size:inherit}", ""]);
// Exports
module.exports = exports;
